import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const PcNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="ubuntu" />;
};
